import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { IPD_COLORS, ipdCardSx } from './ipdColors';
import IpdFormField from './IpdFormField';
import IpdTextField from './IpdTextField';
import IpdButton from './IpdButton';

export default function IpdConfirmDialog({
  open, title, description, onConfirm, onCancel,
  loading, destructive, requireReason, optionalReason, reasonLabel = 'Reason',
  reasonValue, onReasonChange,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
}) {
  const showReasonField = requireReason || optionalReason;

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      PaperProps={{ sx: { ...ipdCardSx, color: IPD_COLORS.textPrimary, minWidth: 360, p: 1 } }}
    >
      <DialogTitle sx={{ color: IPD_COLORS.textPrimary, display: 'flex', alignItems: 'center', gap: 1 }}>
        {destructive && <WarningAmberIcon sx={{ color: IPD_COLORS.error.text }} />}
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: IPD_COLORS.textSecondary }}>
          {description}
        </DialogContentText>
        {showReasonField && (
          <IpdFormField label={reasonLabel} sx={{ mt: 2 }}>
            <IpdTextField
              fullWidth
              hiddenLabel
              value={reasonValue || ''}
              onChange={e => onReasonChange?.(e.target.value)}
              multiline
              rows={2}
            />
          </IpdFormField>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <IpdButton
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          {cancelLabel}
        </IpdButton>
        <IpdButton
          onClick={onConfirm}
          disabled={requireReason && !reasonValue?.trim()}
          loading={loading}
          tone={destructive ? 'red' : 'teal'}
        >
          {confirmLabel}
        </IpdButton>
      </DialogActions>
    </Dialog>
  );
}
